import actions from "@/store/donationGroup/actions";
import state from "@/store/donationGroup/states";
import mutations from "@/store/donationGroup/mutations";

const DonationGroupModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default DonationGroupModule;